import axios from 'axios'
import { getToken } from '@/utils/auth'
import helper from '@/helpers'

// 创建axios实例
const apiArr = [
  // 平台主服务（用户相关）
  {
    service: null,
    // eslint-disable-next-line no-undef
    baseURL: _USER_MAIN_API_ // api 的 base_url
  },
  // 搜索页服务
  {
    service: null,
    // eslint-disable-next-line no-undef
    baseURL: _API_ + 'gtyresource-sale-share/' // api 的 base_url
    // baseURL: '//bg.gty.gzxwtpw.com/' + 'gtyresource-sale-share/'
  },
  // 交易系统相关服务
  {
    service: null,
    // eslint-disable-next-line no-undef
    baseURL: _API_ + 'guituyun-transaction/' // api 的 base_url
    // baseURL: 'https://360p0a2863.goho.co'
  },
  // 仅返回后台地址
  {
    service: null,
    // eslint-disable-next-line no-undef
    baseURL: _API_
  },
  {
    service: null,
    // eslint-disable-next-line no-undef
    baseURL: _HOME_API_
  },
  {
    service: null,
    // eslint-disable-next-line no-undef
    baseURL: _API_ + 'guituyun-copyright'
  }
]

apiArr.map((v, index) => {
  v.service = axios.create({
    // eslint-disable-next-line
    baseURL: v.baseURL, // api 的 base_url
    headers: {
      'Content-Type': 'application/json',
      'EndpointType': 'gtyweb' + new Date().getTime()
    },
    timeout: 600000
  })

  // request拦截器
  v.service.interceptors.request.use(
    config => {
      config.headers['token'] = getToken()
      // config.headers['company_id'] = '2'
      return config
    },
    error => {
      // Do something with request error
      console.log(error) // for debug
      Promise.reject(error)
    }
  )

  // response 拦截器
  v.service.interceptors.response.use(
    response => {
      /**
       * code为非200时抛错 可结合自己业务进行修改
       */
      if (response.data.code !== 200 && response.data.code !== 1) {
        // error处理
        helper.handleError(response.data, response)
        return Promise.reject(response.data)
      } else {
        return response.data
      }
    },
    error => {
      if (!error.config.url.includes('get_token_author')) {
        helper.handleError(error)
      }
      console.log('err' + error) // for debug

      return Promise.reject(error)
    }
  )
})

let mainService = apiArr[0].service // 平台主服务（用户相关）
let searchService = apiArr[1].service // 搜索页服务
let transactionService = apiArr[2].service // 交易系统相关服务
let baseUrlService = apiArr[3].service
let homeService = apiArr[4].service
let copyrightService = apiArr[5].service // 版权服务后台
export {
  mainService,
  searchService,
  transactionService,
  baseUrlService,
  homeService,
  copyrightService
}
